export default "__VITE_ASSET__d5f1c308__"